/* eslint react/jsx-props-no-spreading: ["off"] */

import React from 'react'
import { Card } from './styles'

export default function CardList(props) {
  return (
    <Card {...props} />
  )
}
